












































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import pagelist from "@/components/pagelistcomponent";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import showimg from "@/components/showimg.vue";
import BalanceAdjustOrderEdit from "./AdvanceMoneyAdjustOrdersEdit.vue";
@Component({ components: { showimg, BalanceAdjustOrderEdit } })
export default class balancerechargeaudit extends pagelist {
  //request 请求参数
  get DealerServiceProxy() {
    return new proxy.MerchantServiceProxy();
  }
  get BalanceAdjustOrderServiceProxy() {
    return new proxy.AdvanceMoneyAdjustOrderServiceProxy();
  }
  fxarr = []; //所有分销商
  input = new proxy.AdvanceMoneyAdjustOrderPageInputDto();
  createOrEditShow = false;
  sub_id = 0;
  createrange = []
  auditrange = []
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
    },
    {
      title: "单据编号",
      key: "orderNo",
      width: 200,
    },
    {
      title: "商户",
      key: "merchantName",
    },
    {
      title: "商户号",
      key: "mid",
    },

    {
      title: "调整金额",
      slot: "money",
    },
    {
      title: "调整前金额",
      key: "balance",
    },
    {
      title: "调整后金额",
      key: "afterBalance",
    },
    {
      title: "创建时间",
      slot: "creationTime",
      width: 180,
    },
    {
      title: "调整原因",
      key: "comment",
    },
  ];
  showpic(url) {
    var showpic = this.$refs.showpic as any;
    showpic.larget(url);
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    this.BalanceAdjustOrderServiceProxy.export(this.input).then((x) => {
      location.href =
        AppConsts.remoteServiceBaseUrl +
        '/File/DownloadTempFile?FileToken=' +
        x.fileToken +
        '&fileName=' +
        x.fileName +
        '&fileType=' +
        x.fileType;
    });
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.BalanceAdjustOrderServiceProxy.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  create() {
    this.createOrEditShow = true;
    this.sub_id = 0;
  }
  edit(row) {
    if (!row) {
      if (this.selectedDataItems.length == 0) {
        this.$Notice.error({ title: "请选中一条数据" });
        return;
      }
      row = this.selectedDataItems[0];
    }
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    this.getpage();
  }
}
